module.exports = __webpack_public_path__ + "img/jump-link.713e15f8.svg";